import { useMemo } from 'react';
export default function ServiceSelector({
  services = [], selected = [], onChange,
  disabledIds = [],
}){
  const toggle = id=>{
    if(disabledIds.includes(id)) return;
    onChange( selected.includes(id)
      ? selected.filter(s=>s!==id)
      : [...selected,id] );
  };
  return(
    <div className="flex flex-wrap gap-2">
      {services.map(s=>{
        const active   = selected.includes(s.id);
        const disabled = disabledIds.includes(s.id);
        return(
          <button key={s.id}
            onClick={()=>toggle(s.id)}
            disabled={disabled}
            className={`px-3 py-1 rounded-full text-sm border
              ${active?'bg-blue-600 text-white':'bg-gray-100'}
              ${disabled?'opacity-50 cursor-not-allowed':''}`}>
            {s.name}
          </button>
        );
      })}
    </div>
  );
}
